import { TestReportApi } from './TestReportApi';
import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';
import {
  ReportJsonResponse,
  ReportTypeResponse,
  ReportSubTypeResponse,
} from './types';
import { ResponseError } from './ResponseError';

export class TestReportClient implements TestReportApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async get(path: string): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl('proxy')}${path}`;
    const { token: idToken } = await this.identityApi.getCredentials();
    const response = await fetch(url, {
      headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
    });

    if (!response.ok) {
      const body = response;
      const message = `Request failed with ${response.status} ${response.statusText}, ${body}`;
      throw new ResponseError(message, response);
    }

    const body = await response.json();
    return { status: response.status, body };
  }

  async getTestReport(url: string): Promise<ReportJsonResponse> {
    const response = await this.get(url);
    return {
      body: response.body.content,
      status: response.status,
    };
  }

  async getReportType(url: string): Promise<ReportTypeResponse> {
    const response = await this.get(url);
    return {
      body: response.body,
      status: response.status,
    };
  }

  async getReportSubType(url: string): Promise<ReportSubTypeResponse> {
    const response = await this.get(url);
    return {
      body: response.body,
      status: response.status,
    };
  }
}
